var map = {
	"./number01.svg": "f83a",
	"./number02.svg": "51c2",
	"./number03.svg": "fcc1",
	"./number04.svg": "473b",
	"./number05.svg": "7ecc",
	"./number06.svg": "0a02",
	"./number07.svg": "8ef6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "37b4";